// Van Ark Logo Animation on Load
(function() {
  'use strict';

  // Check if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /**
   * Animates SVG paths with a drawing effect
   * @param {SVGElement} svg - The SVG element to animate
   * @param {number} startDelay - Delay before animation starts (ms)
   * @param {Function} onComplete - Callback when animation completes
   * @param {Object} options - Animation timing options
   */
  function animateLogo(svg, startDelay = 0, onComplete = null, options = {}) {
    if (prefersReducedMotion || !svg) return;
    
    // Only animate if not already animated
    if (svg.hasAttribute('data-animated')) return;
    svg.setAttribute('data-animated', 'true');
    
    // Default timing (for header)
    const staggerDelay = options.staggerDelay || 80;
    const drawDuration = options.drawDuration || 1000;
    const fillDuration = options.fillDuration || 500;
    const completionDelay = options.completionDelay || 500;
    
    const paths = svg.querySelectorAll('path');
    let completedPaths = 0;
    
    paths.forEach((path, index) => {
      // Get the total length of the path for the drawing effect
      const pathLength = path.getTotalLength();
      
      // Set up the starting position
      path.style.strokeDasharray = pathLength;
      path.style.strokeDashoffset = pathLength;
      path.style.opacity = '0';
      
      // Store original fill
      const originalFill = path.getAttribute('fill') || path.style.fill;
      
      // Set stroke properties for drawing animation
      path.style.stroke = originalFill === 'currentColor' ? 'currentColor' : (originalFill || '#000');
      path.style.strokeWidth = '2';
      path.style.fill = 'transparent';
      
      // Create the animation timeline
      const delay = startDelay + (index * staggerDelay); // Stagger each path
      
      // Fade in and draw the path
      setTimeout(() => {
        path.style.transition = `stroke-dashoffset ${drawDuration}ms cubic-bezier(0.65, 0, 0.35, 1), opacity 0.2s ease-in`;
        path.style.opacity = '1';
        path.style.strokeDashoffset = '0';
        
        // After drawing, fill the path
        setTimeout(() => {
          path.style.transition = `fill ${fillDuration}ms ease-in, stroke-width ${fillDuration}ms ease-in`;
          path.style.fill = originalFill || '#000';
          path.style.strokeWidth = '0';
          
          completedPaths++;
          
          // Call onComplete after the last path finishes
          if (completedPaths === paths.length && onComplete) {
            setTimeout(onComplete, completionDelay);
          }
        }, drawDuration);
        
      }, delay);
    });
  }

  // No animation for loader - just dispatch completion event immediately
  function initLoaderAnimation() {
    // Dispatch custom event when loader is ready (no animation)
    window.dispatchEvent(new CustomEvent('loaderAnimationComplete'));
  }

  // Animate header logos after loader is hidden
  function initHeaderAnimation() {
    const headerLogos = document.querySelectorAll('.header__heading-logo-wrapper svg');
    
    headerLogos.forEach((logo) => {
      // Mark as ready to animate (not animated yet)
      if (!logo.hasAttribute('data-animated')) {
        const paths = logo.querySelectorAll('path');
        
        // Small delay to ensure CSS is removed first
        setTimeout(() => {
          paths.forEach((path, index) => {
            // Get the total length of the path for the drawing effect
            const pathLength = path.getTotalLength();
            
            // The target fill should be black (change from white to black)
            const targetFill = '#000';
            
            // Set up the starting position for drawing animation
            // Start completely invisible (transparent stroke and fill)
            path.style.setProperty('fill', 'transparent', 'important');
            path.style.setProperty('stroke', targetFill, 'important');
            path.style.setProperty('stroke-width', '2', 'important');
            path.style.strokeDasharray = pathLength;
            path.style.strokeDashoffset = pathLength;
            
            // Create the animation timeline
            const delay = index * 80; // Stagger each path
            
            // Draw the outline (make stroke visible by animating dashoffset)
            setTimeout(() => {
              path.style.transition = 'stroke-dashoffset 1s cubic-bezier(0.65, 0, 0.35, 1)';
              path.style.strokeDashoffset = '0';
              
              // After drawing outline, fill the path with black
              setTimeout(() => {
                path.style.transition = 'fill 0.5s ease-in, stroke-width 0.5s ease-in';
                path.style.setProperty('fill', targetFill, 'important');
                path.style.setProperty('stroke-width', '0', 'important');
              }, 1000);
              
            }, delay);
          });
        }, 100); // Small delay to ensure page-loading class is removed
        
        logo.setAttribute('data-animated', 'true');
      }
    });
  }

  // Listen for when the loader is hidden
  function observeLoaderRemoval() {
    const loader = document.getElementById('pageLoader');
    
    if (!loader) {
      // No loader present, animate header immediately
      initHeaderAnimation();
      return;
    }

    // Create a mutation observer to watch for the loader being hidden
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (loader.classList.contains('hidden')) {
            // Start header animation when loader is hidden
            setTimeout(() => {
              initHeaderAnimation();
            }, 200);
            observer.disconnect();
          }
        }
      });
    });

    observer.observe(loader, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initLoaderAnimation();
      observeLoaderRemoval();
    });
  } else {
    initLoaderAnimation();
    observeLoaderRemoval();
  }

})();

